

























































































import Vue from 'vue'
import RadioButton from '@/common/components/RadioButton.vue'
import SectionTitle from '@/product/components/SectionTitle.vue'
import Tooltip from '@/common/components/Tooltip.vue'

import { formatSliceYear } from '@/common/utils/common'
enum DELIVERY_METHODS {
  NORMAL_DELIVERY,
  QUICK_DELIVERY
}
export default Vue.extend({
  components: {
    RadioButton,
    SectionTitle,
    Tooltip
  },
  props: {
    isDeliveryFirstOption: {
      type: Boolean,
      required: true
    }
  },
  data(): {
      deliveryMethods: typeof DELIVERY_METHODS
      activeDeliveryMethod: number
    }
    {
      return {
        deliveryMethods: DELIVERY_METHODS,
        activeDeliveryMethod: DELIVERY_METHODS.NORMAL_DELIVERY
      }
  },
  computed: {
    currentDeliveryOptionId(): number {
      return this.isDeliveryFirstOption ? this.$store.state.estimate.first_selected_option.id : this.$store.state.estimate.second_selected_option.id
    },
    isShowQuickDeliverySection(): boolean{
      return this.$store.state.delivery_options?.length
    },
    normalDelivery() {
      return this.$store.state.delivery_options[0]
    },
    quickDelivery() {
      return this.$store.state.delivery_options[1]
    },
    optionTitle() : string {
      return this.isDeliveryFirstOption ? 'first_selected_option' : 'second_selected_option'
    },
    isOrderPlainProduct(): boolean {
      return this.$store.state.isOrderPlainProduct
    },
    isShowQuickDeliveryDetail(): boolean {
      return !!this.quickDelivery.unit_price  && !this.isOrderPlainProduct
    },
    isDefaultOptionQuickDelivery(): boolean {
      if (this.quickDelivery) {
        return this.quickDelivery.printable_sku_id === this.$store.state.estimate.printable_sku_id
      }
      else return false
    }
  },
  watch: {
    currentDeliveryOptionId() {
      if (this.currentDeliveryOptionId === this.normalDelivery.id) {
        this.activeDeliveryMethod = DELIVERY_METHODS.NORMAL_DELIVERY
      } else {
        this.activeDeliveryMethod = DELIVERY_METHODS.QUICK_DELIVERY
      }
    }
  },
  created() {
    if (this.isDefaultOptionQuickDelivery) {
      this.activeDeliveryMethod = DELIVERY_METHODS.QUICK_DELIVERY
    }
  },
  methods: {
    formatSliceYear,
    formatDeliveryDate(date: string) {
      return formatSliceYear(date)?.replace(/\([^)]*\)/,'出荷')
    },
    onChangeDeliveryMethod(method: number, option: { [key: string]: string }, optionDisabled?: boolean) {
      if (this.activeDeliveryMethod === method || optionDisabled) return
      if (!option.selectable && option.first_option_selectable_id) {
        this.$emit('showSnackbar')
        this.$store.commit('setSelectedId', { content: 'first_selected_option', id: option.first_option_selectable_id })
      }
      if (!option.selectable && option.second_option_selectable_id) {
        this.$emit('showSnackbar')
        this.$store.commit('setSelectedId', { content: 'second_selected_option', id: option.second_option_selectable_id })
      }
      this.activeDeliveryMethod = method
      this.$store.commit('setSelectedId', { content: this.optionTitle , id: option.id })
      this.$emit('refreshProductInfo', {})
    }
  }
})
